<template lang="pug">
v-layout(column)
  .pa-4.pa-0-phablet
    h2(v-if='isNew') Nieuw websiteprofiel
    h2(v-else) {{ payload.general.domain }}

    v-tabs.mt-4(v-model='activeTab')
      v-tab(key='general') Algemeen
      v-tab(key='settings') Instellingen
      v-tab(key='form') Aanvraagpagina
      v-tab(key='dealer') Aangesloten dealer

      v-tab-item(key='general', lazy)
        TabGeneral.form(v-model='payload.general', @next='activeTab++', @valid='setValid')

      v-tab-item(key='settings', lazy)
        .form
          p Selecteer welke aanvraagformulier(en) en modules actief moeten zijn voor dit websiteprofiel

          TabSettingsForms(v-model='payload.leaseSettings', @valid='setValid')
          TabSettingsLeaseOptions(v-model='payload.leaseOptions', @valid='setValid', :productType='payload.general.productType')

      v-tab-item(key='form', lazy)
        TabForm(v-model='payload.formStyle', @valid='setValid', :useOrganizationFormStyle.sync='payload.useOrganizationFormStyle')

      v-tab-item(key='dealer', lazy)
        TabDealer.form(v-model='payload.dealerInfo', @valid='setValid')

    //- v-layout.mt-0.form(v-if='isNew')
      v-btn(@click='activeTab--', v-if='activeTab !== 0 && isNew') Vorige
      v-spacer
      v-btn(v-if='activeTab !== 3', @click='activeTab++', color='primary', :disabled='!valid') Volgende
</template>

<script>
export default {
  name: 'WebsiteDetails',

  components: {
    TabGeneral: require('./TabGeneral').default,
    TabSettingsForms: require('./TabSettings/Forms').default,
    TabSettingsLeaseOptions: require('./TabSettings/LeaseOptions').default,
    TabForm: require('./TabForm').default,
    TabDealer: require('./TabDealer').default
  },

  data () {
    return {
      activeTab: 0,
      loading: false,
      payloadUnwatch: null, // Unwatch before save or it triggers the savebar again

      payload: { // default values
        general: {
          name: null,
          productType: null,
          domain: null,
          state: 'enabled'
        },
        leaseSettings: {
          businessLeaseForm: {
            enabled: true,
            ratePercentage: 6,
            defaultNper: 60,
            defaultFv: 0,
            successUrl: null
          },
          privateLeaseForm: {
            enabled: true,
            ratePercentage: 6,
            defaultNper: 60,
            defaultFv: 0,
            successUrl: null
          }
        },
        formStyle: {},
        useOrganizationFormStyle: true,
        dealerInfo: {
          dealerEnabled: false,
          companyName: null,
          streetName: null,
          streetNumber: null,
          streetNumberAddition: null,
          postalCode: null,
          city: null,
          country: 'NL',
          kvkNumber: null,
          vatNumber: null,

          contactInitials: null,
          contactNameInsertion: null,
          contactLastName: null,
          contactEmail: null,
          contactPhone: null
        }
      },

      tabGeneralValid: true,
      tabSettingsFormsValid: true,
      tabSettingsLeaseOptionsValid: true,
      tabDealerValid: true,
      tabFormValid: true
    }
  },

  computed: {
    isNew () {
      return this.$route.params.websiteId === 'new'
    },

    valid () {
      return this.tabGeneralValid &&
        this.tabSettingsFormsValid &&
        this.tabSettingsLeaseOptionsValid &&
        this.tabDealerValid &&
        this.tabFormValid
    }
  },

  methods: {
    setValid ({ tab, valid }) {
      this[tab + 'Valid'] = valid
    },

    setupWatches () {
      this.payloadUnwatch = this.$watch('payload', () => {
        if (!this.isNew) this.$root.$save.show(this.save, null)
      }, { deep: true })
      this.$watch('valid', () => {
        this.$root.$save.show(this.save, null, 'Wil je dit websiteprofiel opslaan?')

        this.$root.$save.setValid(this.valid)
      }) // Must be last
    },

    async save () {
      this.loading = true
      // this.payloadUnwatch() // Unwatch // TODO: not needed anymore?

      delete this.payload.formStyle._id
      delete this.payload.leaseSettings._id

      const variables = {
        name: this.payload.general.name,
        state: this.payload.general.state,
        productType: this.payload.general.productType,
        domain: this.payload.general.domain,
        formStyle: this.payload.formStyle,
        leaseSettings: {
          businessLeaseEnabled: this.payload.leaseSettings.businessLeaseForm.enabled,
          businessLeaseRatePercentage: this.payload.leaseSettings.businessLeaseForm.ratePercentage,
          businessLeaseDefaultNper: this.payload.leaseSettings.businessLeaseForm.defaultNper,
          businessLeaseDefaultFv: this.payload.leaseSettings.businessLeaseForm.defaultFv,

          privateLeaseEnabled: this.payload.leaseSettings.privateLeaseForm.enabled,
          privateLeaseRatePercentage: this.payload.leaseSettings.privateLeaseForm.ratePercentage,
          privateLeaseDefaultNper: this.payload.leaseSettings.privateLeaseForm.defaultNper,
          privateLeaseDefaultFv: this.payload.leaseSettings.privateLeaseForm.defaultFv
        },
        leaseOptions: this.payload.leaseOptions,
        successUrl: this.payload.successUrl,
        useOrganizationFormStyle: this.payload.useOrganizationFormStyle
      }

      // Fix some data and remove some properties
      if (this.payload.dealerInfo.dealerEnabled) {
        variables.dealerInfo = this.payload.dealerInfo

        delete variables.dealerInfo.dealerEnabled
      }

      // Save for after saving website cause we might not have a websiteId yet
      let backgroundImageUrl = this.payload.formStyle.backgroundImageUrl
      let logoUrl = this.payload.formStyle.logoUrl

      // Upload images after saving because if this is a new website, we don't have an ID yet
      if (backgroundImageUrl) {
        if (backgroundImageUrl instanceof File) {
          backgroundImageUrl = await this.$store.dispatch('files/upload', {
            type: 'form_background',
            data: backgroundImageUrl
          })

          variables.formStyle.backgroundImageUrl = backgroundImageUrl
        }
      }

      if (logoUrl) {
        if (logoUrl instanceof File) {
          logoUrl = await this.$store.dispatch('files/upload', {
            type: 'form_logo',
            data: logoUrl
          })

          variables.formStyle.logoUrl = logoUrl
        }
      }

      let websiteId
      try {
        if (this.isNew) {
          variables.orgId = this.$store.state.organization.currentOrgId

          const addedWebsite = await this.$store.dispatch('graphqlMutation', {
            name: 'addWebsite',
            variables,
            deleteCacheQueries: ['getWebsites', 'getWebsitesWithDealerInfo']
          })

          websiteId = addedWebsite.id

          this.$root.$snackbar.show('Websiteprofiel toegevoegd')

          this.$router.push({
            name: 'all websites'
          })
        } else {
          websiteId = this.$route.params.websiteId

          variables.id = websiteId

          await this.$store.dispatch('graphqlMutation', {
            name: 'updateWebsite',
            variables,
            deleteCacheQueries: ['getWebsites', 'getWebsite', 'getWebsitesWithDealerInfo']
          })

          this.$root.$snackbar.show('Websiteprofiel opgeslagen')
        }
      } catch (error) {
        console.error(error)

        this.$root.$snackbar.show('Er is iets fout gegaan. Probeer het nog een keer.')
      }

      this.loading = false

      this.setupWatches()
    }
  },

  mounted () {
    // Read hidden tab query param
    if (this.$route.query.tab) {
      this.activeTab = parseInt(this.$route.query.tab)
    }
  },

  async created () {
    // Initialize website object
    if (!this.isNew) {
      const website = await this.$store.dispatch('graphqlQuery', {
        name: 'getWebsite',
        variables: {
          id: this.$route.params.websiteId
        }
      })

      this.$set(this.payload.general, 'name', website.name)
      this.$set(this.payload.general, 'state', website.state)
      this.$set(this.payload.general, 'domain', website.domain)
      this.$set(this.payload.general, 'productType', website.productType)

      if (website.dealerInfo) {
        Object.assign(this.payload.dealerInfo, website.dealerInfo)
        this.payload.dealerInfo.dealerEnabled = true

        delete this.payload.dealerInfo.__v
        delete this.payload.dealerInfo._id
      }

      if (website.formStyle) {
        this.payload.formStyle = Object.assign({}, website.formStyle)
      }

      this.payload.useOrganizationFormStyle = website.useOrganizationFormStyle

      const businessLeaseForm = {
        enabled: website.leaseSettings.businessLeaseEnabled,
        ratePercentage: website.leaseSettings.businessLeaseRatePercentage,
        defaultNper: website.leaseSettings.businessLeaseDefaultNper,
        defaultFv: website.leaseSettings.businessLeaseDefaultFv
      }

      this.$set(this.payload.leaseSettings, 'businessLeaseForm', businessLeaseForm)

      const privateLeaseForm = {
        enabled: website.leaseSettings.privateLeaseEnabled,
        ratePercentage: website.leaseSettings.privateLeaseRatePercentage,
        defaultNper: website.leaseSettings.privateLeaseDefaultNper,
        defaultFv: website.leaseSettings.privateLeaseDefaultFv
      }

      this.$set(this.payload.leaseSettings, 'privateLeaseForm', privateLeaseForm)

      this.$set(this.payload, 'leaseOptions', website.leaseOptions)
    }

    // Setup watch after payload is initialized so it isnt triggered
    setTimeout(() => { // Hack. We don't want to trigger the valid watch yet and user input isnt faster than 100ms so no problem
      this.setupWatches()
    }, 100)
  }
}
</script>

<style lang="scss" scoped>
</style>
